import React, { useState, useEffect, useRef } from 'react';
import './HeroCarousel.css';

interface CarouselItem {
  id: number;
  title: string;
  subtitle: string;
  imageUrl: string;
}

const HeroCarousel: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const carouselItems: CarouselItem[] = [
    {
      id: 1,
      title: '找装修公司',
      subtitle: '一站式装修服务平台，让装修更简单',
      imageUrl: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&q=80'
    },
    {
      id: 2,
      title: '买装修材料',
      subtitle: '优质材料，价格透明，送货上门',
      imageUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80'
    },
    {
      id: 3,
      title: '找装修师傅',
      subtitle: '经验丰富，技术精湛，服务周到',
      imageUrl: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80'
    }
  ];

  // 自动播放轮播
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (autoPlay) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [autoPlay, carouselItems.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
    setAutoPlay(false); // 用户操作后暂停自动播放
    setTimeout(() => setAutoPlay(true), 5000); // 5秒后恢复自动播放
  };

  const goToPrevSlide = () => {
    const prevIndex = (currentIndex - 1 + carouselItems.length) % carouselItems.length;
    setCurrentIndex(prevIndex);
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const goToNextSlide = () => {
    const nextIndex = (currentIndex + 1) % carouselItems.length;
    setCurrentIndex(nextIndex);
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  // 触摸事件处理函数
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      // 向左滑动，切换到下一张
      goToNextSlide();
    } else if (touchEndX.current - touchStartX.current > 50) {
      // 向右滑动，切换到上一张
      goToPrevSlide();
    }
  };

  return (
    <section className="hero">
      <div 
        className="hero-carousel" 
        id="heroCarousel"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {carouselItems.map((item, index) => (
          <div
            key={item.id}
            className={`carousel-item ${index === currentIndex ? 'active' : ''}`}
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0)), url('${item.imageUrl}')`
            }}
          >
            <div className="carousel-content">
              <h1 className="carousel-title">{item.title}</h1>
              <p className="carousel-subtitle">{item.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="carousel-controls">
        <button className="carousel-control" id="carouselPrev" onClick={goToPrevSlide}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <button className="carousel-control" id="carouselNext" onClick={goToNextSlide}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>

      <div className="carousel-indicators" id="carouselIndicators">
        {carouselItems.map((_, index) => (
          <div
            key={index}
            className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
            data-index={index}
            onClick={() => goToSlide(index)}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default HeroCarousel;